import React, { Component } from 'react'
import {
    Card,
    Row,
    Col,
    Input,
    Button,
    Pagination,
    Modal,
    Empty,
    message
} from 'antd'
import styled from 'styled-components'
import {
    ShoppingCartOutlined,
    ReadOutlined,
    PlusOutlined,
    EyeTwoTone,
    DeleteTwoTone,
    EditTwoTone,
    CloseCircleTwoTone
} from '@ant-design/icons'
import {
    getCategoryBanners,
    getCategoryBanner,
    updateCategoryBanner,
    removeCategoryBanner
} from '../../../services/apiServices'
import LoadingModal from '../../../commons/Modal/Loading'
import CategorySelectorModal from '../../../commons/Modal/CategorySelectorModal/CategorySelectorModal'
import BannerEditorModal from '../../../commons/Modal/Banner/BannerEditorModal'

const { Search } = Input

const NUMBER_PER_PAGE = 16

const Container = styled(Card)`
    .cover-block {
        width: 100%;
        height: 150px;
        background-size: cover;
        background-position: center;
        background-color: #f5f5f5;
    }
`

class CategoryBanner extends Component {
    state = {
        isLoading: false,
        isOpenCategorySelectorModal: false,
        banners: [],
        page: 1,
        total: 0,
        selectedCategoryId: 0,
        selectedBanner: {},
        isOpenBannerEditorModal: false,
        keyword: ''
    }

    componentDidMount() {
        this.getBanners()
    }

    async getBanners() {
        let { type } = this.props
        this.setState({ isLoading: true })
        try {
            let { banners = [], total = 0 } = await getCategoryBanners({
                body: {
                    type: type == 'PRODUCT' ? 'product_cat' : 'category',
                    page: this.state.page,
                    keyword: this.state.keyword,
                    number_per_page: NUMBER_PER_PAGE
                }
            })
            this.setState({
                isLoading: false,
                banners,
                total
            })
        } catch (error) {
            console.log(error)
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async getBanner(id, onSuccess) {
        this.setState({ isLoading: true })
        try {
            let banner = await getCategoryBanner({
                body: { id }
            })
            this.setState({ isLoading: false })
            console.log(banner)
            onSuccess && onSuccess(banner)
        } catch (error) {
            console.log(error)
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setBanner(id, data, onSuccess) {
        this.setState({ isLoading: true })
        try {
            await updateCategoryBanner({
                body: { id, info: data }
            })
            this.setState({
                isLoading: false
            })
            message.success(this.props.T('SAVED'))
            onSuccess && onSuccess()
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async removeBanner(id, onSuccess) {
        this.setState({ isLoading: true })
        try {
            await removeCategoryBanner({
                body: { id }
            })
            this.setState({
                isLoading: false
            })
            message.success(this.props.T('DONE'))
            onSuccess && onSuccess()
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onChangePage(page) {
        this.setState({ page }, () => this.getBanners())
    }

    onToggleCategorySelectorModal(status) {
        this.setState({
            isOpenCategorySelectorModal: status
        })
    }

    onSelectCategory(id) {
        this.onToggleCategorySelectorModal(false)
        this.getBanner(id, banner => {
            this.setState(
                {
                    selectedCategoryId: id,
                    selectedBanner: banner
                },
                () => this.onToggleBannerEditorModal(true)
            )
        })
    }

    onToggleBannerEditorModal(status) {
        this.setState({
            isOpenBannerEditorModal: status
        })
    }

    onSearch(keyword) {
        this.setState({ keyword }, () => this.getBanners())
    }

    onRemoveBanner(id) {
        showRemoveConfirm(this.props.T.bind(this), () => {
            this.removeBanner(id, () => this.getBanners())
        })
    }

    onSaveBanner(info) {
        this.onToggleBannerEditorModal(false)
        this.setBanner(this.state.selectedCategoryId, info, () => {
            this.getBanners()
        })
    }

    render() {
        let { T, type } = this.props

        return (
            <Container
                title={
                    <span className="text-xl">
                        {type == 'PRODUCT' ? (
                            <ShoppingCartOutlined />
                        ) : (
                            <ReadOutlined />
                        )}{' '}
                        {T(type)} - {T('CATEGORY_BANNER')}
                    </span>
                }
                extra={
                    <>
                        <Search
                            placeholder={T('SEARCH')}
                            enterButton
                            style={{ width: 200, marginRight: 10 }}
                            onSearch={this.onSearch.bind(this)}
                        />

                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() =>
                                this.onToggleCategorySelectorModal(true)
                            }>
                            {T('SELECT_CATEGORY')}
                        </Button>
                    </>
                }>
                {this.state.keyword && (
                    <Row justify="center" style={{ marginBottom: 30 }}>
                        <Col>
                            <span style={{ fontSize: 20, fontWeight: 'bold' }}>
                                {T('SEARCH')}: {this.state.keyword}
                            </span>
                            <Button
                                type="text"
                                shape="circle"
                                icon={
                                    <CloseCircleTwoTone twoToneColor="#ff4d4f" />
                                }
                                onClick={() => this.onSearch('')}
                            />
                        </Col>
                    </Row>
                )}

                {!this.state.isLoading && this.state.banners.length == 0 && (
                    <Empty />
                )}

                <Row gutter={16}>
                    {this.state.banners.map(banner => (
                        <Col
                            key={banner.id}
                            xs={24}
                            md={12}
                            xl={8}
                            xxl={6}
                            style={{ marginBottom: 20 }}>
                            <Card
                                cover={
                                    <div
                                        className="cover-block"
                                        style={{
                                            backgroundImage: `url(${banner.info?.cover_image})`
                                        }}></div>
                                }
                                actions={[
                                    <a
                                        key="view"
                                        href={banner.url}
                                        target="_blank">
                                        <EyeTwoTone twoToneColor="#fa8c16" />
                                    </a>,
                                    <EditTwoTone
                                        key="edit"
                                        onClick={() =>
                                            this.onSelectCategory(banner.id)
                                        }
                                    />,
                                    <DeleteTwoTone
                                        key="remove"
                                        twoToneColor="#ff4d4f"
                                        onClick={() =>
                                            this.onRemoveBanner(banner.id)
                                        }
                                    />
                                ]}>
                                <Card.Meta
                                    style={{ textAlign: 'center' }}
                                    title={banner.name}
                                    description={
                                        banner.parent_id == 0
                                            ? T('MAIN_MENU')
                                            : T('SUBMENU')
                                    }
                                />
                            </Card>
                        </Col>
                    ))}
                </Row>

                {this.state.total > 0 && (
                    <Row justify="center" style={{ marginTop: 30 }}>
                        <Col>
                            <Pagination
                                current={this.state.page}
                                defaultPageSize={NUMBER_PER_PAGE}
                                onChange={this.onChangePage.bind(this)}
                                total={this.state.total}
                            />
                        </Col>
                    </Row>
                )}

                <CategorySelectorModal
                    T={T}
                    categoryType={type == 'PRODUCT' ? 'PRODUCT' : 'POST'}
                    isOpenModal={this.state.isOpenCategorySelectorModal}
                    onSubmit={this.onSelectCategory.bind(this)}
                    onClose={() => this.onToggleCategorySelectorModal(false)}
                />

                <BannerEditorModal
                    T={T}
                    isOpen={this.state.isOpenBannerEditorModal}
                    info={this.state.selectedBanner}
                    onOk={this.onSaveBanner.bind(this)}
                    onCancel={() => this.onToggleBannerEditorModal(false)}
                />

                <LoadingModal isOpen={this.state.isLoading} />
            </Container>
        )
    }
}

const showRemoveConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REMOVE_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

export default CategoryBanner
